import { FormFeedback } from "./FormFeedback";
import { CascadiaFieldErrorsProps } from "./types";
import { Stack } from "../../../foundations/grid-layout/Stack";

export function FieldErrors(props: CascadiaFieldErrorsProps) {
  const { children } = props;

  const errors = Array.isArray(children)
    ? children.filter(Boolean)
    : [children].filter(Boolean);

  if (errors.length < 1) {
    return null;
  }

  return (
    <Stack gap="space-0" className="has-errors">
      {errors.map((error) => (
        <FormFeedback key={error} type="invalid">
          {error}
        </FormFeedback>
      ))}
    </Stack>
  );
}
